// extracted by mini-css-extract-plugin
export default {"center":"Spinner_center__y2XTx","spinner":"Spinner_spinner__D+IeZ","spinner-aib1d7":"Spinner_spinner-aib1d7__7Re1N"};